import { TagInput as BaseTagInput, TagInputProps } from 'components/TagInput/TagInput'
import { useField } from 'formik'

interface Props extends Omit<TagInputProps, 'tags' | 'onChange'> {
  name: string
}

export const TagInput = ({ name, ...props }: Props) => {
  const [field, meta, helpers] = useField(name)
  const { touched, error } = meta

  return (
    <BaseTagInput
      {...props}
      tags={field.value}
      onChange={(tags) => helpers.setValue(tags)}
      error={touched ? error : undefined}
    />
  )
}
